<template>
	<div class="document_title_bar">
		<div class="doc_top_bread">
			<router-link to="/document" class="bread_link">文档中心</router-link>
			<span v-for="item in barData">
				<i class="el-icon-arrow-right"></i>
				<span>{{item}}</span>
			</span>
		</div>
	</div>
</template>
<script>
	export default{
		props: {
            pathData:null,
        },
		data(){
			return{
				barData:[]
			}
		},
		watch:{

		},
		methods:{

		},
		mounted(){
			
			if (this.pathData){
				console.log(this.pathData,"this.pathData")
				this.barData = this.pathData;
			}
		}
	}
</script>
<style lang="less" rel="stylesheet/less">
	@import '../less/index.less';
	.document_title_bar{
		.doc_top_bread{
			font-size: 14px;
		    line-height: 24px;
		    padding: 10px 0;
		    border-bottom: 1px solid #ebebeb;
		    .bread_link{
		    	color:@primary-color;
		    	padding-left:0px;
		    	font-size: 14px;
		    	span{font-size: 14px;}
		    }
		}
	}
</style>	


// WEBPACK FOOTER //
// src/components/documentTitleBar.vue